import { handsel } from '@/api/advertiser'

export default {
    components: {
    },
    props: {
        showHandselForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => ({ titles: [] })
        }
    },
    created() {
        this.actionName = '转赠落地页'

        //提交的数据
        let advertisers = []
        //需要处理的数据
        let advertisersSelect = []

        this.model.advertisers.forEach( (item,index) => {
            //如果有多资产，需要选择
            if (item.apps.length > 1) {
                advertisersSelect.push({id:item.advertiser_id,index: index, advertiser_id:item.out_id, advertiser_name:item.advertiser_name, instance_id: null, path: null, appShow: {}, apps:item.apps})
            } 
            advertisers.push({id:item.advertiser_id, advertiser_id:item.out_id, advertiser_name:item.advertiser_name, instance_id: item.apps[0].instance_id, path: item.apps[0].path, appShow: item.apps[0]})
        })

        this.advertisersSelect = advertisersSelect
        this.advertisers = advertisers

        // console.log('this.advertisersSelect',this.advertisersSelect)
        // console.log('this.advertisers',this.advertisers)
     },
    data() {
        return {
            labelCol: { span: 5 },
            wrapperCol: { span: 17 },
            medias: [],
            corporations: [],
            loading: false,
            actionName: '操作',
            rules: {
                site_id: [{ required: true, message: '请选择被转赠的落地页', trigger: 'change' }],
            },
            result: {
                success: [],
                errors: [],
            },
            showResult: false,
            showSubmit: true,
            advertisers: [],
            advertisersSelect: [],
            showSelectApps: false,
        }
    },
    computed: {
        actType() {
            return this.actionName
        }
    },
    mounted() {
    },
    watch: {},
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            })
        },
        storeOrUpdate() {
            let error = ''
            this.advertisers.forEach(element => {
                if (!element.path) {
                    error += element.advertiser_id+','
                }
            });

            if (error) {
                error = '广告主：' + error + '需要填写小程序和路径'
                return this.$message.error(error)
            }

            const data = Object.assign({}, this.model)
            data.advertisers = this.advertisers
            
            console.log('提交的数据', data)

            this.result.success = []
            this.result.errors = []

            this.loading = true
            handsel(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.result = res.data
                    //出现弹窗，提示结果不关闭，关闭弹窗，才刷新
                    this.showResult = true
                    // this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
                this.showSubmit = false
            }).catch(() => {
                this.loading = false
                this.showSubmit = true
            })
        },
        closerResult () {
            this.showResult = false
            this.$emit('success')
            this.close()
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showHandselForm', false)
        },
        changeApp (item, option) {
            const app = option.data.attrs.app
            const index = option.data.attrs.index
            this.advertisers[index].instance_id = app.instance_id
            this.advertisers[index].path = app.path
            this.advertisers[index].appShow = app
        },
    }
}
